<template>
    <b-card no-body>
        <AgentLineDrawer ref="drawer_agent_line" />
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    label="Search"
                    v-model="searchQuery"
                    v-on:input="debouncedHandler"
                    prepend-icon="fas fa-search"
                    placeholder="Search...(case-sensitive)"
                    >
                    </base-input>
                    <base-input label="Filter by Status" class="mx-4">
                        <el-select
                            v-model="main_status"
                            multiple
                            collapse-tags
                            placeholder="Select Status"
                            >
                            <el-option
                                v-for="item in mainStatusList"
                                :key="item.status_id"
                                :label="item.status"
                                :value="item.status_id"
                            >
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
                <b-col cols="12" md="3" >
                    <b-button class="float-right px-3 py-2" variant="outline-secondary" disabled>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#73839C" d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z"/></svg>
                        Filters
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
        <div class="table-listings">
            <el-table
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                empty-text="No Data"
                @selection-change="selectionChange"
                v-loading="isTableLoading"
            >
                <el-table-column
                    type="selection"
                    width="55"
                ></el-table-column>

                <el-table-column
                    label="Name"
                    prop="name"
                    min-width="185"
                >
                    <template slot-scope="scope">
                        <p class="name top-line font-weight-500 text-primary mb-0 cursor-pointer">
                            {{ scope.row.name }}
                        </p>
                        <p class="bottom-line">{{ scope.row.id }}</p>
                    </template>
                </el-table-column>

                <el-table-column
                    min-width="100"
                >
                    <template slot-scope="scope">
                        <b-button variant="primary" class="px-2 py-1 m-1" @click="$refs.drawer_agent_line.viewAgentLine()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M9 2v6h2v3H5c-1.11 0-2 .89-2 2v3H1v6h6v-6H5v-3h6v3H9v6h6v-6h-2v-3h6v3h-2v6h6v-6h-2v-3c0-1.11-.89-2-2-2h-6V8h2V2H9Z"/>
                            </svg>
                        </b-button>
                    </template>
                </el-table-column>

                <el-table-column
                    label="Approval Status"
                    prop="status"
                    min-width="185"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line"
                            :class="{'text-danger': scope.row.status === 'Not Approved', 'text-success': scope.row.status !== 'Not Approved'}">
                            {{ scope.row.status }}
                        </p>
                    </template>
                </el-table-column>

                <el-table-column
                    label="Position/Assigned Hub(ID)"
                    prop="position"
                    min-width="185"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">{{ scope.row.position }}</p>
                        <p class="bottom-line">{{ scope.row.assigned_hub }} ({{ scope.row.hub_id }})</p>
                    </template>
                </el-table-column>

                <el-table-column
                    label="Contact No."
                    prop="contact_no"
                    min-width="185"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">{{ scope.row.contact_no }}</p>
                    </template>
                </el-table-column>

                <el-table-column
                    label="NRIC"
                    prop="nric"
                    min-width="185"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">{{ scope.row.nric }}</p>
                    </template>
                </el-table-column>

                <el-table-column
                    label="Created/Updated"
                    prop="created_at"
                    min-width="185"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">{{ scope.row.created_at }}</p>
                        <p class="bottom-line">{{ scope.row.updated_at }}</p>
                    </template>
                </el-table-column>

                <el-table-column
                    fixed="right"
                    width="50"
                >
                    <template slot-scope="scope">
                        <el-dropdown trigger="click"  style="cursor: pointer">
                            <p class="el-dropdown-link mb-0 top-line">
                                <b-icon icon="three-dots-vertical"></b-icon>
                            </p>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>View Change Log</el-dropdown-item>
                                <el-dropdown-item>Resend Payslip</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>

            </el-table>
        </div>
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>
    </b-card>
</template>
<script>
import { Table, TableColumn, Select, Option, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { debounce } from '@/assets/js/httpImports.js'
import AgentLineDrawer from '@/views/Commission/Recruitment/AgentLineDrawer'

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        AgentLineDrawer,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
    data() {
        return {
            isTableLoading: false,
            propsToSearch:['name'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            mainStatusList: [
                {status_id: 1, status: "Approved"},
                {status_id: 2, status: "Not Approved"},
            ],
            main_status:'',
            tableData: [
                {
                    name: 'Terrance Kong',
                    id: 'R00222',
                    status: 'Not Approved',
                    position: 'Agent',
                    assigned_hub: 'Hub ABC',
                    hub_id: 'H003',
                    email: 'terrance@mail.com',
                    contact_no: '010-998XXXX',
                    nric: '850405-07-XXXX',
                    created_at: '7 Aug, 2022',
                    updated_at: '3 days ago'
                }
            ],
            
        }
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
    }
}
</script>